<template>
	<div class="inactive-container">
		<h2 class="inactive-title">Coming Soon!</h2>
		<h3 class="inactive-subtitle">
			Delicious food menu launching soon! Check back later to see the
			items and start your order
		</h3>
		<img
			class="inactive-image"
			src="/images/2k-launch.png"
			alt="Coming Soon"
		/>
	</div>
</template>

<style scoped>
.inactive-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 50px;
}

.inactive-image {
	margin-top: 73px;
	height: 177px;
}

.inactive-title {
	font-size: 30px;
}

.inactive-subtitle {
	color: var(--gR-base-90);
}
</style>

<script>
export default {
	name: "ComingSoonSection"
}
</script>